import { watch, type Ref } from 'vue';

const HIGHLIGHT_CLASS = 'highlight';

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const clearHighlights = (container: HTMLElement) => {
  container.querySelectorAll(`.${HIGHLIGHT_CLASS}`).forEach((span) => {
    const parent = span.parentNode;

    if (!parent) {
      return;
    }

    parent.replaceChild(document.createTextNode(span.textContent || ''), span);
    parent.normalize();
  });
};

const highlightLabels = (container: HTMLElement, query: string) => {
  clearHighlights(container);

  const trimmedQuery = query.trim();

  if (!trimmedQuery) {
    return;
  }

  const regex = new RegExp(`(${escapeRegExp(trimmedQuery)})`, 'gi');

  container.querySelectorAll('.ui-tag__label').forEach((labelEl) => {
    const text = labelEl.textContent || '';

    if (!regex.test(text)) {
      return;
    }

    regex.lastIndex = 0;
    labelEl.innerHTML = text.replace(regex, `<span class="${HIGHLIGHT_CLASS}">$1</span>`);
  });
};

export const useRubricsSearchHighlight = (containerRef: Ref<HTMLElement | null>, searchQuery: Ref<string>) => {
  watch(
    searchQuery,
    () => {
      const container = containerRef.value;

      if (!container) {
        return;
      }

      highlightLabels(container, searchQuery.value);
    },
    { flush: 'post' },
  );
};
